import { ConfigurationTypes } from '../../vendor_core/core/src/const/ConfigurationTypes';
import IComponentsConfig from '../../vendor_core/core/src/managers/contracts/configurations/IComponentsConfig';
import { BitmapMoneyField } from '../../vendor_core/core/src/views/BitmapMoneyField';
import { MoneyField } from '../../vendor_core/core/src/views/MoneyField';

class ComponentsConfig implements IComponentsConfig {
    type: ConfigurationTypes = ConfigurationTypes.COMPONENTS;

    moneyFields = {
        hideCentsConditions: {
            fields: ["pt_sym"],
            condition: (data: BitmapMoneyField | MoneyField): boolean => {
                let result = false;
                if (data.value > 999) {
                    result = true;
                }
                return result;
            }
        }
    };
}

export default new ComponentsConfig();
